import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import Admin from "./layouts/Admin";
import Auth from "./layouts/Auth";
import Login from "views/auth/Login";
import { Dashboard } from "views/admin/Dashboard";
import Comments from "views/admin/Support/Comments/Comments";
import Crm from "views/admin/Support/Crm/Crm";
import Users from "views/admin/Accounting/Users/Users";
import Directors from "views/admin/Accounting/Directors/Directors";
import Admins from "views/admin/Accounting/Admins/Admins";
import Cafes from "views/admin/Accounting/Cafes/Cafes";
import Resellers from "views/admin/Accounting/Resellers/Resellers";
import Promotions from "views/admin/Accounting/Promotions/Promotions";
import Packages from "views/admin/Seals/Packages/Packages";
import Coupons from "views/admin/Seals/Coupons/Coupons";
import Orders from "views/admin/Seals/Orders/Orders";
import Roles from "views/admin/Accounting/Roles/Roles";
import RoleAdd from "views/admin/Accounting/Roles/Add";
import RoleEdit from "views/admin/Accounting/Roles/Edit";
import ProductCategory from "views/admin/Settings/ProductCategory/ProductCategory";

import PlusProductCategory from "views/admin/Settings/PlusProductCategory/PlusProductCategory";
import ShopProductCategory from "views/admin/Settings/ShopProductCategory/ShopProductCategory";
import BlockedUsers from "views/admin/Accounting/BlockUsers/BlockUsers";
import ResetPassword from "views/auth/ResetPassword";
import { Provider } from "react-redux";
import store from "./store/Store";
import reportWebVitals from "./reportWebVitals";
import ActivityFields from "./views/admin/Settings/ActivityFields/ActivityFields";
import Casts from "./views/admin/Settings/Casts/Casts";
import Genres from "./views/admin/Settings/Genres/Genres";
import DeliveryMethods from "./views/admin/Settings/DeliveryMethods/DeliveryMethods";
import Menus from "./views/admin/Settings/Menus/Menus";
import MenusAdd from "./views/admin/Settings/Menus/Add";
import MenusEdit from "./views/admin/Settings/Menus/Edit";
import Sliders from "./views/admin/Settings/Sliders/Sliders";
import SlidersAdd from "./views/admin/Settings/Sliders/Add";
import SlidersEdit from "./views/admin/Settings/Sliders/Edit";
import Products from "./views/admin/Products/List";
import AddProducts from "./views/admin/Products/Wizard/Wizard";
import Lives from "views/admin/Products/Live/Lives";

import Tickets from "views/admin/Products/Tickets/Tickets";
import CafeTickets from "views/admin/Products/Tickets/CafeTickets";
import Plans from "views/admin/Products/Tickets/Plans";
import Generals from "./views/admin/Settings/Generals/Generals";
import Files from "views/admin/Products/Files/Files";
import News from "views/admin/Products/News/News";
import Tags from "views/admin/Settings/Tag/Tags";
import Shows from "views/admin/Settings/Shows/Shows";
import ShowAdd from "views/admin/Settings/Shows/Add";
import ShowEdit from "views/admin/Settings/Shows/Edit";
import Video from "views/admin/Products/Video/Video";
import Staffs from "views/admin/Accounting/Staffs/Staffs";
import Coachs from "views/admin/Accounting/Coach/Coachs";
import Referees from "views/admin/Accounting/Referee/Referees";
import Players from "views/admin/Accounting/Player/Players";
import Stadiums from "views/admin/Accounting/Stadium/Stadiums";
import Teams from "views/admin/Accounting/Team/Teams";
import Transfers from "views/admin/Accounting/Transfer/Transfers";
import Leagues from "views/admin/Accounting/League/Leagues";
import Matchs from "views/admin/Accounting/Match/Matchs";
import Statistics from "views/admin/Accounting/Statistic/Statistics";

import LeaguesNew from "views/admin/Accounting/New/League/Leagues";
import TeamsNew from "views/admin/Accounting/New/Team/Teams";
import MatchsNew from "views/admin/Accounting/New/Match/Matchs";
import Channels from "views/admin/Products/Channel/Channels";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/auth" exact element={<Auth />}>
            <Route path="/auth/login" exact element={<Login />} />
            <Route
              path="/auth/resetpassword"
              exact
              element={<ResetPassword />}
            />
            <Route path="/auth" element={<Navigate to="/auth/login" />} />
          </Route>
          <Route path="/" exact element={<Admin />}>
            <Route path="/dashboard" exact element={<Dashboard />} />
            <Route path="/support/comments" exact element={<Comments />} />
            <Route path="/support/crm" exact element={<Crm />} />
            <Route path="/users/users" exact element={<Users />} />
            <Route path="/users/staffs" exact element={<Staffs />} />
            <Route path="/users/coachs" exact element={<Coachs />} />
            <Route path="/users/referees" exact element={<Referees />} />
            <Route path="/users/players" exact element={<Players />} />
            <Route path="/users/admins" exact element={<Admins />} />
            <Route path="/users/directors" exact element={<Directors />} />
            <Route path="/users/resellers" exact element={<Resellers />} />
            <Route path="/users/cafes" exact element={<Cafes />} />
            <Route path="/users/roles" exact element={<Roles />} />
            <Route path="/users/promotions" exact element={<Promotions />} />
            <Route path="/users/roles/add" exact element={<RoleAdd />} />
            <Route path="/users/roles/edit/:id" exact element={<RoleEdit />} />
            <Route path="/users/blocked" exact element={<BlockedUsers />} />
            <Route path="/settings/general" exact element={<Generals />} />
            <Route
              path="/settings/product-categories"
              exact
              element={<ProductCategory />}
            />
            <Route path="/settings/product-tags" exact element={<Tags />} />
            <Route path="/settings/shows" exact element={<Shows />} />

            <Route path="/settings/shows/add" exact element={<ShowAdd />} />
            <Route
              path="/settings/shows/edit/:id"
              exact
              element={<ShowEdit />}
            />

            <Route
              path="/settings/plus-product-categories"
              exact
              element={<PlusProductCategory />}
            />
            <Route
              path="/settings/shop-product-categories"
              exact
              element={<ShopProductCategory />}
            />
            <Route
              path="/settings/activity-Fields"
              exact
              element={<ActivityFields />}
            />
            <Route path="/settings/casts" exact element={<Casts />} />
            <Route path="/settings/genres" exact element={<Genres />} />
            <Route
              path="/settings/delivery-methods"
              exact
              element={<DeliveryMethods />}
            />
            <Route path="/settings/menus" exact element={<Menus />} />
            <Route path="/settings/menus/add" exact element={<MenusAdd />} />
            <Route
              path="/settings/menus/edit/:id"
              exact
              element={<MenusEdit />}
            />
            <Route path="/settings/Sliders" exact element={<Sliders />} />
            <Route
              path="/settings/Sliders/add"
              exact
              element={<SlidersAdd />}
            />
            <Route
              path="/settings/Sliders/edit/:id"
              exact
              element={<SlidersEdit />}
            />
            <Route
              path="/products/Plus"
              exact
              element={<Products plus={true} />}
            />
            <Route path="/products/lives" exact element={<Lives />} />
            <Route path="/products/channels" exact element={<Channels />} />

            <Route path="/products/files" exact element={<Files />} />
            <Route path="/products/news" exact element={<News />} />
            <Route path="/stadiums" exact element={<Stadiums />} />
            <Route path="/teams" exact element={<Teams />} />
            <Route path="/transfers" exact element={<Transfers />} />
            <Route path="/leagues" exact element={<Leagues />} />
            <Route path="/products/video" exact element={<Video />} />
            <Route path="/matchs" exact element={<Matchs />} />
            <Route path="/statistics" exact element={<Statistics />} />

            <Route path="/leagues-new" exact element={<LeaguesNew />} />
            <Route path="/teams-new" exact element={<TeamsNew />} />
            <Route path="/matchs-new" exact element={<MatchsNew />} />

            {/* <Route
              path="/products/festival/:id/widgets"
              exact
              element={<FestivalWidgets />}
            /> */}
            <Route
              path="/products/wizard/:id"
              exact
              element={<AddProducts />}
            />
            <Route
              path="/products/festival/:festival_id/:festival_name"
              exact
              element={<Products />}
            />
            <Route
              path="/products/festival/:festival_id"
              exact
              element={<Products />}
            />

            <Route
              path="/products/festival/:festival_id/wizard"
              exact
              element={<AddProducts festival={true} />}
            />
            <Route
              path="/products/festival/:festival_id/wizard/:id"
              exact
              element={<AddProducts festival={true} />}
            />
            <Route path="/products/wizard" exact element={<AddProducts />} />
            <Route path="/products/:type" exact element={<Products />} />
            <Route path="/products" exact element={<Products />} />

            <Route
              path="/tickets/:product_id/:plan_name/:product_name"
              exact
              element={<Tickets />}
            />
            <Route
              path="/tickets/:product_id/:plan_name"
              exact
              element={<Tickets />}
            />
            <Route
              path="/cafe-tickets/:plan_id"
              exact
              element={<CafeTickets />}
            />

            <Route
              path="/cafe-tickets/:plan_id/:plan_name"
              exact
              element={<CafeTickets />}
            />
            <Route
              path="/plans/:product_id/:product_name"
              exact
              element={<Plans />}
            />
            <Route path="/seals/packages" exact element={<Packages />} />
            <Route path="/seals/coupons" exact element={<Coupons />} />
            <Route path="/seals/orders" exact element={<Orders />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
